'use client';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AppBootScreen } from '../components/app-boot-screen.tsx';
import { AppProviders } from '../components/providers/app-providers.tsx';
import { ErrorBoundary } from '../features/error-boundary/error-boundary.tsx';
import '../styles/globals.css';

function MyApp() {
    return (
        <ErrorBoundary>
            <AppProviders>
                <Suspense fallback={<AppBootScreen />}>
                    <Outlet />
                </Suspense>
            </AppProviders>
        </ErrorBoundary>
    );
}

export default MyApp;
